import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { VehicleDto } from '../interface/vehicle.dto';
import { Vehicle } from '../model/vehicle';
import dayjs from 'dayjs';

export class VehicleFactory extends QuickFactory implements Factory<Vehicle> {
  private bbxId: string;

  constructor(bbxId?: string) {
    super();
    this.bbxId = bbxId;
  }

  build(o: VehicleDto): Vehicle {
    const vehicle: Vehicle = new Vehicle();
    this.generateProperty(vehicle, o);
    vehicle.date = o.date ?? dayjs(new Date()).format('DD/MM/YYYY');

    return vehicle;
  }

  getApi(): string {
    return this.bbxId
      ? `administration/fleet/${this.bbxId}/vehicles/`
      : 'administration/fleet/vehicles';
  }
}
